import { createContext, Dispatch, FC, useContext, useReducer } from 'react';
import { reducer } from './reducer';
import { StoreAction, StoreContextState } from '../types';
import {chartTableList, networkList, seasonalTrendList, weatherRadioButtons } from '../constants';
import { ONEMIN, ONESEC} from './common';
import moment from 'moment';
let today = new Date();
let todaylocal = new Date(today.getFullYear(), today.getMonth(), today.getDate(), today.getHours(), 0, 0);
let past = todaylocal.getTime() - (30*ONEMIN);
let future = todaylocal.getTime() + (30*ONEMIN)-ONESEC;

const getInitialState =(): StoreContextState => ({
  openCalc: false,
  network: [networkList[0]],
  seasonalTrend: [seasonalTrendList[0], seasonalTrendList[1]],
  fuelList:[],
  categoryList:[],
  subCatList: [{code_key: "None",code_table_id: -1, code_value:'None', type:'None'}],
  methodList: [{code_key: "None",code_table_id: -1, code_value:'None', type:'None'}],

  nfdrFuelModel: 'Y',

  fsMapEndDate: (moment().utc()).toISOString(),
  fsMapStartDate: (moment().startOf('year').utc()).toISOString(),
  fsMapFuel:null,
  fsMapCategory: null,
  fsMapMethod: {code_key: "None",code_table_id: -1, code_value:'None', type:'None'},
  fsMapSubCat: {code_key: "None",code_table_id: -1, code_value:'None', type:'None'},

  ProdBanner: false,
  mapDataType:'',
  userTokens:null,
  user:null,
  allLegend: [],
  stationSearched: false,
  SF100Displayed: false,
  GT05Displayed: false,
  GT50Displayed: false,
  NOAA100Displayed: false,
  site_type: ['RAWS (SAT NFDRS)'],
  latLong: [39.18276551033839, -105.93185337434936],
  popupContent: [],
  chartTable: chartTableList[0],
  initialLoad: true,
  elevationFilterValues:[0,12120],
  userTimeZone:{code: 'UTC', id: ['UTC', 'GMT'], offset:0},
  filters:[],
  currentWeatherObs: [],
  currentWXMinMax: [],
  currentFeaturesRendered:[],
  currentZoom: 3,
  currentSliderDate: todaylocal.getTime(),
  currentDate: todaylocal.getTime(),
  station_clicked_on_map: '',
  station_clicked:false,
  callCompleted: false,
  dates: [new Date(past), new Date(future)],
  midDate: todaylocal.getTime(),
  wind_speed: false,
  wind_direction:false,
  boundaries: [],
  alerts: [],
  table: [],
  all_stations: [],
  selectedStation: "test",
  currStationIds:'',
  allStationIds: [],
  selectedElement:null,
  selectedRadio: weatherRadioButtons[0],
  selectedBaseMap: {id:'topo'},
  selectedFireModel: 'Y',
  colorLegend: false,
  toolBarOpen: true,
  weatherData: [],
});

export const StoreContext = createContext<StoreContextType>(
  null as never
);

export const useStoreContext = () => useContext(StoreContext);

export type StoreContextType = [
  StoreContextState,
  Dispatch<StoreAction>
]

export const StoreContextProvider: FC = ({ children }) =>{
  const [state, dispatch] = useReducer(reducer, getInitialState());

  return(
    <StoreContext.Provider value={[state, dispatch]}>
      {children}
    </StoreContext.Provider>

  )
}